import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MiscService } from 'app/shared/services/misc.service';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { DashboardService } from '../dashboard.service';
import * as dashboardActions from './dashboard.actions'

@Injectable({
    providedIn: 'root'
})

export class DashboardEffects {
    constructor(
        private actions$: Actions,
        private dashboardService: DashboardService,
        private toastr: ToastrService,
        private miscService: MiscService
    ) {}

    // fetchOutstandingBalance$ = createEffect(() =>
    //   this.actions$.pipe(
    //     ofType(dashboardActions.fetchOutstandingBalance),
    //     exhaustMap((action) =>
    //       this.dashboardService
    //         .getOutstandingBalance()
    //         .pipe(
    //           exhaustMap((response: any) => [
    //               dashboardActions.fetchOutstandingBalanceSuccess({ outstandingBalance: response.data[0] }),
    //           ]),
    //           catchError((error: HttpErrorResponse) => {
    //               this.toastr.error(error.error?.errors, 'An error occured');
    //               return of(dashboardActions.fetchOutstandingBalanceFailed())
    //           }
    //           )
    //         )
    //     )
    //   )
    // );

}